export default "__VITE_ASSET__4614246b__"